import { Store as $store } from '@store';

// Check if user is logged in while browsing non-public pages
export const pagesGuard = async (to, from, next) => {
  if (
    to.matched.some((record) => !record.meta || !record.meta.public)
    && !$store.getters['app/isLoggedIn']
  ) {
    next({ name: 'login', query: { next: to.fullPath } });

    // Check if user is admin while browsing admin pages
  } else if (
    to.matched.some((record) => record.meta && record.meta.requiresAdmin)
    && !$store.getters['app/isAdmin']
  ) {
    next({ name: 'forbidden' });
  } else {
    next();
  }
};
